import { NgModule } from '@angular/core';
import { YandexMetrikaAbTestVariantDirective } from './yandex-metrika-ab-test-variant.directive';

@NgModule({
  declarations: [YandexMetrikaAbTestVariantDirective],
  exports: [YandexMetrikaAbTestVariantDirective],
})
export class YandexMetrikaAbTestModule {}
